<!--Selector-->
<div class="SelectorMain">
	<!--Grid-->
	<div class="SelectorGrid">
		<label>Search In:</label>
		<select class="form-control" [(ngModel)]="ContainerID" (ngModelChange)="onContainerChanged($event)">
			<option *ngFor="let r of lstContainer" [ngValue]="r.SchoolID">
				<label *ngIf="r.SchoolNumber != undefined">[{{ r.SchoolNumber }}] - {{ r.SchoolName }}</label>
				<label *ngIf="r.SchoolNumber == undefined">{{ r.SchoolName }}</label>
			</option>
		</select>

		<!-- <label *ngIf="lstDistrict.length > 0">District:</label>
        <select *ngIf="lstDistrict.length > 0" class="form-control" [(ngModel)]="DistrictID">
            <option *ngFor="let r of lstDistrict" [ngValue]="r.DistrictID">{{r.DistrictName}}</option>
        </select> -->

		<label *ngIf="lstSchoolGroup.length > 0">Container:</label>
		<select *ngIf="lstSchoolGroup.length > 0" class="form-control" [(ngModel)]="SchoolGroupID">
			<option *ngFor="let r of lstSchoolGroup" [ngValue]="r.SchoolGroupID">
				{{ r.SchoolGroupDesc }}
			</option>
		</select>

		<label *ngIf="lstFacility.length > 0">Facility:</label>
		<select *ngIf="lstFacility.length > 0" class="form-control" [(ngModel)]="FacilityID">
			<option *ngFor="let r of lstFacility" [ngValue]="r.FacilityID">
				{{ r.FacilityName }}
			</option>
		</select>

		<label *ngIf="lstDynamicGroup.length > 0">Group:</label>
		<select *ngIf="lstDynamicGroup.length > 0" class="form-control" [(ngModel)]="DynamicGroup" (ngModelChange)="onDynamicGroupChanged($event)">
			<option *ngFor="let r of lstDynamicGroup" [ngValue]="r">
				{{ r.DynamicGroupDesc }}
			</option>
		</select>

		<label *ngIf="lstDynamicGroupValues.length > 0">Value:</label>
		<div *ngIf="lstDynamicGroupValues.length > 0" class="AlertDiv">
			<select class="form-control" [(ngModel)]="DynamicValueID" (ngModelChange)="onDynamicValueChanged($event)">
				<option *ngFor="let r of lstDynamicGroupValues" [ngValue]="r.ListID">
					{{ r.ListDesc }}
				</option>
			</select>

			<p *ngIf="ShowDesc() == true" class="AlertDescText">
				{{ AlertDesc }}
			</p>
		</div>

		<label>Include Deactivated Alerts:</label>
		<input type="checkbox" class="CHK" [(ngModel)]="IncludeDeactivated" />
	</div>

	<!--Button-->
	<div class="SelectorButtons">
		<button [disabled]="DisableSearch == true || MainLoading == true" class="btn btn-primary" (click)="onSearch()">Search</button>
	</div>
</div>

<caass-student-alerts-table [MainLoading]="MainLoading" [lstIncidents]="lstIncidents" (RefreshTable)="onSearch()" (LockSearch)="onDisableSearchChange($event)">
</caass-student-alerts-table>
